












































































import { ObjectFactory } from '@/config/objectFactory';
import { GPSLocation, LiveRideDetails, Route } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import GoogleMap from '../components/GoogleMap.vue';
import { CommonUtils } from '@/util/commonUtils';
import { DateUtils } from '@/util/dateUtils';
@Component({
    mixins: [validationMixin],
    components: {
        GoogleMap,
    },
    data() {
        return {
            showMap: false,
            driverLocation: {
                latitude: 0,
                longitude: 0,
            },
            pickupAddressCoordinates: {
                lat: 0,
                lng: 0,
            },
            dropoffAddressCoordinates: {
                lat: 0,
                lng: 0,
            },
            requestId: '',
            appointmentTime: '',
            ETAForDriverArrival: '',
            driverPhone: '',
            driverName: '',
            vehicleDetails: {
                makeModal: '',
                year: '',
                color: '',
                licensePlate: '',
            },
            pickupAddress: '',
            dropoffAddress: '',
            isLinkValid: true,
            patientPickedUp: false,
            mapRefreshCount: 0,
        };
    },
})
export default class RideLiveLocation extends Vue {
    private isRouteRefreshing = true;
    private iHttpService = ObjectFactory.getHttpService();
    private routeId: string = '';
    private driverLocation: GPSLocation | undefined = undefined;

    public async mounted() {
        const routeDetails = await this.getRouteDetails();
        if (routeDetails.pickupAddress && routeDetails.dropoffAddress) {
            this.$data.pickupAddressCoordinates.lat = routeDetails.pickupAddress.latitude;
            this.$data.pickupAddressCoordinates.lng = routeDetails.pickupAddress.longitude;
            this.$data.dropoffAddressCoordinates.lat = routeDetails.dropoffAddress.latitude;
            this.$data.dropoffAddressCoordinates.lng = routeDetails.dropoffAddress.longitude;
            this.$data.driverPhone = routeDetails.driverPhone;
            this.$data.pickupAddress = this.trimAddress(routeDetails.pickupAddress.fullAddress);
            this.$data.dropoffAddress = this.trimAddress(routeDetails.dropoffAddress.fullAddress);
            this.$data.ETAForDriverArrival = routeDetails.etaToDriverArrival ? DateUtils.formatDate
                (routeDetails.etaToDriverArrival, DateUtils.FORMAT_DATETIME_AM_PM) : '';
            this.$data.driverName = routeDetails.driverName;
            if (routeDetails.vehicleDetails) {
                this.$data.vehicleDetails.makeModal = `${routeDetails.vehicleDetails.make}/${routeDetails.vehicleDetails.model}`;
                this.$data.vehicleDetails.year = routeDetails.vehicleDetails.year;
                this.$data.vehicleDetails.color = routeDetails.vehicleDetails.color;
                this.$data.vehicleDetails.licensePlate = routeDetails.vehicleDetails.licenseNumberPlate;
            }
            if (routeDetails.driverLocation) {
                this.$data.driverLocation = routeDetails.driverLocation;
            }
            this.$data.requestId = routeDetails.requestId;
            this.$data.appointmentTime = DateUtils.formatDate(routeDetails.appointmentTime,
                DateUtils.FORMAT_DATETIME_AM_PM);
        }
        this.$data.showMap = true;
        setInterval(async () => {
            await this.refreshRouteLocation();
        }, 10000);
    }

    private async refreshRouteLocation() {
        let googleMap = this.$refs.liveLocationMap as any;
        const route = await this.getRouteDetails();
        // some asynchronous operations or rendering delays to get googleMap so keep it as it is
        if (!googleMap) {
            googleMap = this.$refs.liveLocationMap as any;
        }
        if (route.driverLocation && googleMap) {
            this.animateCarIcon(
                this.$data.driverLocation,
                route.driverLocation,
                (newPosition) => {
                    googleMap.updateLocation(newPosition);
                },
            );
            // Update the last known driver location
            this.$data.driverLocation = route.driverLocation;
        }

        // Handle patient pickup logic and refresh map if necessary
        if (route.patientPickedUp && this.$data.mapRefreshCount === 0) {
            this.refreshMap();
            this.$data.mapRefreshCount++;
            this.$data.patientPickedUp = true;
        }
    }

    /**
     * Smoothly animate the car icon from the current location to the new location
     */
     private animateCarIcon(
        startLocation: GPSLocation,
        endLocation: GPSLocation,
        updateCallback: (location: GPSLocation, isFinalPosition: boolean) => void,
    ) {
        const totalDuration = 2000; // Adjust for desired animation speed
        const distanceLatitude = endLocation.latitude - startLocation.latitude;
        const distanceLongitude = endLocation.longitude - startLocation.longitude;
        const thresholdDistance = 0.0001; // Minimum distance change to trigger re-centering
        let lastCenterUpdate = startLocation;

        const animate = (startTime: number) => {
            const currentTime = performance.now();
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / totalDuration, 1); // Clamp progress between 0 and 1

            // Interpolate latitude and longitude for smooth transition
            const currentLatitude = startLocation.latitude + distanceLatitude * progress;
            const currentLongitude = startLocation.longitude + distanceLongitude * progress;
            const currentPosition = { latitude: currentLatitude, longitude: currentLongitude };

            // Update car icon position
            const isFinalPosition = progress === 1;
            updateCallback(currentPosition, isFinalPosition);

            // Re-center map only if it's the final position or the icon has moved significantly
            const distanceMoved = Math.sqrt(
                Math.pow(currentLatitude - lastCenterUpdate.latitude, 2) +
                Math.pow(currentLongitude - lastCenterUpdate.longitude, 2),
            );

            if (isFinalPosition || distanceMoved > thresholdDistance) {
                // Update the last re-center position to avoid frequent updates
                lastCenterUpdate = currentPosition;
            }

            // Continue animation if not completed
            if (progress < 1) {
                requestAnimationFrame(() => animate(startTime));
            }
        };
        requestAnimationFrame((startTime) => animate(startTime));
    }




    private async getRouteDetails(): Promise<LiveRideDetails> {
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `track/${this.$route.params.id}`,
        };
        const response = await this.iHttpService.get<LiveRideDetails>(apiRequest);
        if (response.success && response.data) {
            return  response.data;
        } else {
            this.$data.isLinkValid = false;
            throw new Error('traking link is expired');
        }
    }

    private refreshMap() {
        this.$data.showMap = false;
        setTimeout(() => {
            this.$data.showMap = true;
        }, 500);
    }

    private trimAddress(address: string) {
        let updatedAddress = '';
        if (address.length > 50) {
            updatedAddress = address.substring(0, 50) + '...';
        } else {
            updatedAddress = address;
        }
        return updatedAddress;
    }
}
